import React from 'react';
import { FiltersContainer, FilterColumn, StyledTextField } from '../styled';
import DropdownSelect from '../../../components/DropdownSelect';
import CustomDatePicker from '../../../components/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { FiltersProps } from '../types/StaffAttendanceTypes';

const StaffAttendanceFilters: React.FC<FiltersProps> = ({
  role,
  setRole,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  setHasSearched,
  roleOptions
}) => {
  const handleRoleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    const target = e.target as HTMLInputElement & { value: string };
    setRole(target.value);
    setHasSearched(false);
  };

  const handleFromDateChange = (newValue: Dayjs | null) => {
    const value = newValue ? dayjs(newValue).format('YYYY-MM-DD') : '';
    setFromDate(value);
    setHasSearched(false);
  };

  const handleToDateChange = (newValue: Dayjs | null) => {
    const value = newValue ? dayjs(newValue).format('YYYY-MM-DD') : '';
    setToDate(value);
    setHasSearched(false);
  };

  const checkYesterdayDate = dayjs().subtract(1, 'day');

  return (
    <FiltersContainer>
      <FilterColumn>
        <StyledTextField>
          <DropdownSelect
            label='Role'
            name='role'
            value={role}
            onChange={handleRoleChange}
            options={roleOptions}
            size='small'
            placeholder='Select Role'
            required
          />
        </StyledTextField>
      </FilterColumn>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        localeText={{
          fieldMonthPlaceholder: () => 'MMM'
        }}
      >
        <FilterColumn>
          <StyledTextField>
            <CustomDatePicker
              label='From Date'
              value={fromDate ? dayjs(fromDate) : null}
              onChange={handleFromDateChange}
              format='DD MMM, YYYY'
              maxDate={checkYesterdayDate}
              required
            />
          </StyledTextField>
        </FilterColumn>
        <FilterColumn>
          <StyledTextField>
            <CustomDatePicker
              label='To Date'
              value={toDate ? dayjs(toDate) : null}
              onChange={handleToDateChange}
              format='DD MMM, YYYY'
              minDate={fromDate ? dayjs(fromDate) : undefined}
              maxDate={checkYesterdayDate}
              required
              disabled={!fromDate}
            />
          </StyledTextField>
        </FilterColumn>
      </LocalizationProvider>
    </FiltersContainer>
  );
};

export default StaffAttendanceFilters;
